import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function () {
  return (
    <Box>
      <Typography>Not Found!</Typography>
    </Box>
  );
}
